import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { AnalyticsRollupService } from './analytics-rollup.service';
import { MerchantAnalyticsController } from './merchant-analytics.controller';
import { MerchantAnalyticsService } from './merchant-analytics.service';
import { PlatformAnalyticsController } from './platform-analytics.controller';
import { PlatformAnalyticsService } from './platform-analytics.service';

@Module({
  controllers: [MerchantAnalyticsController, PlatformAnalyticsController],
  providers: [
    PrismaService,
    AnalyticsRollupService,
    MerchantAnalyticsService,
    PlatformAnalyticsService,
  ],
  exports: [AnalyticsRollupService, MerchantAnalyticsService, PlatformAnalyticsService],
})
export class AnalyticsModule {}
